<template>
  <div class="how-it-works-info">
    <no-ssr>
      <b-popover
        :target="targetId"
        :container="targetId"
        triggers="hover"
        :html="true"
        placement="bottomright"
      >
        <how-it-works-info></how-it-works-info>
      </b-popover>
    </no-ssr>
  </div>
</template>

<style lang="sass" scoped>

</style>

<style lang="sass">
  // Sorry for this
  .popover
    max-width: unset !important

</style>

<script>

  import HowItWorksInfo from '~/components/header/how-it-works-info';

  export default {
    props: ['target-id'],
    components: {
      HowItWorksInfo
    }
  }

</script>
